/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export default interface Categories {
  tabTitle1 ? : string;
  tabTitle2 ? : string;
  tabTitle3 ? : string;
  tabTitle4 ? : string;
  tabTitle5 ? : string;
  disableColumn1 ? : boolean;
  disableColumn2 ? : boolean;
  disableColumn3 ? : boolean;
  disableColumn4 ? : boolean;
  disableColumn5 ? : boolean;
  categoryLinks1 ? : string;
  categoryLinks2 ? : string;
  categoryLinks3 ? : string;
  categoryLinks4 ? : string;
  categoryLinks5 ? : string;
  metadata ? : any;
}

export const Props = {
  tabTitle1: String,
  tabTitle2: String,
  tabTitle3: String,
  tabTitle4: String,
  tabTitle5: String,
  disableColumn1: Boolean,
  disableColumn2: Boolean,
  disableColumn3: Boolean,
  disableColumn4: Boolean,
  disableColumn5: Boolean,
  categoryLinks1: String,
  categoryLinks2: String,
  categoryLinks3: String,
  categoryLinks4: String,
  categoryLinks5: String,
  metadata: Object,
}

export const WrapperProps = {
  tabTitle1: String,
  tabTitle2: String,
  tabTitle3: String,
  tabTitle4: String,
  tabTitle5: String,
  disableColumn1: Boolean,
  disableColumn2: Boolean,
  disableColumn3: Boolean,
  disableColumn4: Boolean,
  disableColumn5: Boolean,
  categoryLinks1: String,
  categoryLinks2: String,
  categoryLinks3: String,
  categoryLinks4: String,
  categoryLinks5: String,
  metadata: Object,
}

export class CategoriesBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class CategoriesInstance implements Categories {
      tabTitle1 ? : string;
      tabTitle2 ? : string;
      tabTitle3 ? : string;
      tabTitle4 ? : string;
      tabTitle5 ? : string;
      disableColumn1 ? : boolean;
      disableColumn2 ? : boolean;
      disableColumn3 ? : boolean;
      disableColumn4 ? : boolean;
      disableColumn5 ? : boolean;
      categoryLinks1 ? : string;
      categoryLinks2 ? : string;
      categoryLinks3 ? : string;
      categoryLinks4 ? : string;
      categoryLinks5 ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

      }
    }
    return new CategoriesInstance(props);
  }
}
